<template>
  <div id="app">
    <router-view />
    <notifications group="foo" position="bottom right" />


  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {};
  },
  components: {},
  methods: {
    registerActive() {
      axios
        .get(this.$global.endpoint + "/user/isactive")
        .then(res => {})
        .catch(error => {
          console.error(error);
        });
    }
  },
  created() {
    this.interval = setInterval(() => {
      if (this.$store.getters.user.id != undefined) {
        this.registerActive();
      }
    }, 30000);
  }
};
</script>

<style scoped>
.has-error {
  border-color: #a94442 !important;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;
}
</style>

<!--
<style>
#app {
  margin-top: 60px
}
</style>

-->
